<h5>{{ 'TERMINAL_SCREEN.TITLE' | translate }}</h5>
<p>
  {{ 'TERMINAL_SCREEN.DESCRIPTION' | translate }}
</p>
<img alt='' src='../../../../../../assets/theme/camera-placeholder.png' width='100%'>
